import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { formatDMY } from "../../utils/date";

const Events = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const cleanDescription = (text = "") =>
    text
      .replace(/&nbsp;/g, " ")
      .replace(/<[^>]*>/g, "")
      .trim();
  // const events = location.state;
  // const eventArray = Object.values(events);

  const events = location.state?.Events || [];
  const eventArray = Array.isArray(events) ? events : [events];

const navigateBack = () => {
    navigate(-1);
  };
  
  return (
    <div className="">
      <div className="d-flex justify-content-end mb-3">
        {/* <button className="btn btn-outline-dark btn-sm" onClick={navigateBack}>
          <i className="bx bx-arrow-back me-2"></i> Back
        </button> */}
      </div>

      <div className="row g-4">
        {eventArray?.map((event) => (
          <div key={event.id} className="col-12">
            {/* Main Event Card */}
            <div className="card border-0 shadow-sm mb-4">
              <img
                src={event.file_url.replace("/thumb", "")}
                className=""
                alt={event.name}
                loading="lazy"
                style={{ height: "300px", objectFit: "cover" }}
              />
              <div className="card-body text-center">
                <h4 className="fw-bold">{event.Event_Name}</h4>
                <p className="text-muted fw-semibold fs-6">{event.Event_Title}</p>
              </div>
            </div>

            {/* Detail Cards */}
            <div className="row g-4 mb-4">
              <div className="col-md-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body text-center">
                    <h6 className="card-title text-uppercase fw-bold text-secondary">Start Date</h6>
                    <p className="mb-0 fw-medium">{formatDMY(event.start_date)}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body text-center">
                    <h6 className="card-title text-uppercase fw-bold text-secondary">End Date</h6>
                    <p className="mb-0 fw-medium">{formatDMY(event.end_date)}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body text-center">
                    <h6 className="card-title text-uppercase fw-bold text-secondary">Place / Timezone</h6>
                    <p className="mb-0 fw-medium">
                      {event.Location} / {event.timeZone}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="fw-bold mb-2">Event Description</h5>
                <p className="text-muted text-justify" style={{ whiteSpace: "pre-wrap" }}>
                <span>{event?.description ? cleanDescription(event.description) : "No description available"}</span>
                      </p>
                
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Events;
